import { render, staticRenderFns } from "./zone-header.vue?vue&type=template&id=533b9cca&scoped=true&"
import script from "./zone-header.vue?vue&type=script&lang=js&"
export * from "./zone-header.vue?vue&type=script&lang=js&"
import style0 from "./zone-header.vue?vue&type=style&index=0&id=533b9cca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b9cca",
  null
  
)

export default component.exports